import { Component, Inject, OnInit } from "@angular/core";
import { AsyncPipe, CommonModule, JsonPipe } from "@angular/common";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { FlexModule } from "@angular/flex-layout/flex";
import {FormBuilder, FormControl, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatTableModule } from "@angular/material/table";
import {
  BusinessOverdraftPricingComparisonDialogData,
  BusinessOverdraftPricingComparisonDialogDatasource,
  BusinessOverdraftPricingComparisonDialogResult,
  CurrencyInputValue,
  OverdraftPaymentBreakupDialogData,
} from "@portal-workspace/grow-shared-library";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import {LooseCurrencyPipe} from "../../pipes/loose-currency.pipe";
import {EditableTextComponent} from '../../components/editable-component/editable-text.component';
import {EditablePercentageComponent} from '../../components/editable-component/editable-percentage.component';
import {EditableNumberComponent} from '../../components/editable-component/editable-number.component';
import {EditableCurrencyComponent} from '../../components/editable-component/editable-currency.component';
import {UntilDestroy} from "@ngneat/until-destroy";
import {Subscription} from "rxjs";
import {ApplicationDialogService, setupUntilDestroy} from "@portal-workspace/grow-ui-library";
import {PercentagePipe} from '../../pipes/percentage.pipe';


@UntilDestroy({arrayName: 'subscriptions'})
@Component({
  templateUrl: './business-overdraft-pricing-comparison.dialog.html',
  styleUrls: ['./business-overdraft-pricing-comparison.dialog.scss'],
  standalone: true,
  imports: [
    FlexModule,
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule,
    FormsModule,
    MatCardModule,
    MatInputModule,
    MatTableModule,
    JsonPipe,
    AsyncPipe,
    MatButtonModule,
    LooseCurrencyPipe,
    EditableTextComponent,
    EditablePercentageComponent,
    EditableNumberComponent,
    EditableCurrencyComponent,
    PercentagePipe
]
})
export class BusinessOverdraftPricingComparisonDialog implements OnInit {

  subscriptions: Subscription[] = [];

  dataSource: BusinessOverdraftPricingComparisonDialogDatasource = [];
  currentValue: OverdraftPaymentBreakupDialogData;
  newValue: OverdraftPaymentBreakupDialogData;

  formControlDocFee!: FormControl<CurrencyInputValue>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: BusinessOverdraftPricingComparisonDialogData,
    private dialogRef: MatDialogRef<BusinessOverdraftPricingComparisonDialog, BusinessOverdraftPricingComparisonDialogResult>,
    private applicationDialogService: ApplicationDialogService,
    private formBuilder: FormBuilder,
  ) {
    this.currentValue = data.currentValue
    this.newValue = data.newValue
  }

  ngOnInit() {
    setupUntilDestroy(this);
    this.formControlDocFee = this.formBuilder.control(this.newValue.term.docFee, [Validators.required]);
    this.subscriptions.push(this.formControlDocFee.valueChanges.pipe(
      // doc fee was changed
    ).subscribe());
    this.dataSource = [
      {
        type: 'currency',
        name: 'Facility Limit',
        currentValue: this.currentValue.term.facilitylimit,
        newValue: this.newValue.term.facilitylimit,
      },
      {
        type: 'percentage',
        name: 'Interest Rate',
        currentValue: this.currentValue.term.interestRate,
        newValue: this.newValue.term.interestRate,
        newValueClick: (newValue) => {
          this.applicationDialogService.openInterestRateCalculationLogDialog({
            logs: this.newValue?.term?.calculationLog ?? [],
          });
        },
      },
      {
        type: 'percentage',
        name: 'RBA Rate',
        currentValue: this.currentValue.term.rbaRate,
        newValue: this.newValue.term.rbaRate,
      },
      {
        type: 'currency',
        name: 'Monthly Facility Fee',
        currentValue: this.currentValue.term.monthlyFacilityFee,
        newValue: this.newValue.term.monthlyFacilityFee,
      },
      {
        type: 'currency',
        name: 'Doc/Annual fee ($)',
        currentValue: this.currentValue.term.docFee,
        newValue: this.newValue.term.docFee,
        formControl: this.formControlDocFee,
      },
      {
        type: 'currency',
        name: 'Brokerage(ex GST)',
        currentValue: this.currentValue.term.brokerageDollar,
        newValue: this.newValue.term.brokerageDollar,
      },
      {
        type: 'text',
        name: 'Additional Commission',
        currentValue: this.data.currentAdditionalCommission ? 'Yes' : 'No',
        newValue: this.data.newAdditionalCommission ? 'Yes' : 'No',
      },
    ];
  }

  onAcceptQuotation($event: Event) {
    this.dialogRef.close({
      acceptedQuotation: true,
      docFee: this.formControlDocFee.value ?? this.currentValue.term.docFee,
    });
  }

  onClose($event: Event) {
    this.dialogRef.close();
  }


}
